import React from "react";
import Select from "react-select";
import { Field } from "./Field";
import { filterSelectStyles } from "./selectStyles";

/**
 * Generic option picker for simple {value, label} lists.
 * Used for status selects, org selects, and any non-virtualized dropdown.
 *
 * Props:
 *  - label: string shown above the select (optional)
 *  - id: string used for label htmlFor / input id
 *  - options: array of { value, label } objects
 *  - value: currently selected option ({ value, label }) or null
 *  - onChange: (option | null) => void
 *  - placeholder: string (default "Select...")
 *  - disabled: boolean
 *  - isClearable: boolean (default true)
 *  - isSearchable: boolean (default true)
 */
export const OptionSelect = ({
  label,
  id,
  options = [],
  value,
  onChange,
  placeholder = "Select...",
  disabled = false,
  isClearable = true,
  isSearchable = true,
}) => {
  const normalizedValue = value?.value
    ? { value: value.value, label: value.label }
    : null;

  return (
    <Field label={label} htmlFor={id}>
      <Select
        inputId={id}
        value={normalizedValue}
        onChange={onChange}
        options={options}
        isDisabled={disabled}
        placeholder={placeholder}
        isClearable={isClearable}
        isSearchable={isSearchable}
        styles={filterSelectStyles()}
        getOptionValue={(option) => option.value}
        getOptionLabel={(option) => option.label}
      />
    </Field>
  );
};